/**
 * Copyright 2018 Phenix Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
define([
    'phenix-web-lodash-light',
    'phenix-web-assert',
    'phenix-web-batch-http',
    './MQProtocol',
    './Binary'
], function(_, assert, BatchHttp, MQProtocol, Binary) {
    'use strict';

    function BatchHttpProtocol(uri, protocols, type, options, apiVersion) {
        assert.isStringNotEmpty(uri, 'uri');
        assert.isArray(protocols, 'protocols');
        assert.isStringNotEmpty(type, 'type');
        assert.isObject(options, 'options');

        var bufferedHttpOptions = _.assign({}, options || {}, {contentType: 'application/protobuf'});
        var mqProtocol = new MQProtocol(protocols, apiVersion);

        return new BatchHttp(uri, bufferedHttpOptions, _.bind(prepareRequest, this, mqProtocol, type), _.bind(prepareResponse, this, mqProtocol, type));
    }

    function prepareRequest(mqProtocol, type, data) {
        return Binary.toString(mqProtocol.encode(type, data));
    }

    function prepareResponse(mqProtocol, type, data) {
        return mqProtocol.decode(type + 'Response', Binary.toByteArray(data));
    }

    return BatchHttpProtocol;
});